import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import { UTCdateToFormattedDate } from '../../utils/format';

ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement, Tooltip, Legend);

export default function OdometerGraph({ chart }) {

  //create timeline grapgh
  if (!chart) {
    return null; // or some other appropriate value
  }
  var data = {
    labels: chart.slice(0)
      .reverse()
      .map((x) => UTCdateToFormattedDate(x[0].ReadingDate)),
    datasets: [
      {
        label: 'Km value',
        fill: true,
        data: chart.slice(0)
          .reverse()
          .map((x) => x[0].Reading),
        backgroundColor: ['rgba(197, 43, 43, 0.18)'],
        borderColor: ['rgba(197, 43, 43, 1)'],
        pointBackgroundColor: 'rgba(197, 43, 43, 0.35)',
        borderWidth: 3,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };
  return (
    <div className="odometer-graph">
      <Line data={data} options={options} />
    </div>
  );
}
